import * as yup from "yup";

const downloadPDFFormSchema = yup.object().shape({
  name: yup
    .string()
    .required("Please enter your name")
    .min(3, "Please enter full name"),
  mobileCountryCode: yup.string(),
  mobile: yup
    .string()
    .test(
      "mobile",
      "Number should be minimum 8 characters",
      (value) => !value || value.length >= 8
    )
    .max(14, "Number should be maximum 14 characters"),
  email: yup.string().email("Please enter a valid email address"),
  formError: yup
    .string()
    .test(
      "formError",
      "Please provide either a valid email or a valid phone number",
      function () {
        const { email, mobile } = this.parent || {};
        if (email || mobile) {
          return true;
        }
        return false;
      }
    ),
});

export default downloadPDFFormSchema;
